import { FunctionsHttpError } from '@supabase/supabase-js'

// deactivate-device deletes the underlying Supabase auth user (not just
// flips devices.status), so a deactivated device's calls fail auth.getUser()
// itself — every cashier Edge Function (award-stamps, redeem-reward,
// correct-stamps, restore-reward, verify/change-cashier-pin) returns 401 for
// that, not 403. 403 only happens for the narrower case where the user still
// resolves but fails the account_type/device-active check (e.g. a stale
// token for a device row that's been reassigned). Both mean the same thing
// client-side: this session is no longer a valid cashier device session.
const DEVICE_INVALID_STATUSES = new Set([401, 403])

/** verify_qr is called via supabase.rpc(), not an Edge Function, so a
 *  rejection comes back as a normal 200 response with { error: 'forbidden' }
 *  rather than an HTTP error — useVerifyQr throws this class for that case
 *  so it can still funnel into the same kick-out check. */
export class DeviceForbiddenError extends Error {
  constructor() { super('device_forbidden') }
}

/** True when a cashier-facing request was rejected because the device is no
 *  longer active — the underlying access token stays valid after admin
 *  deactivation until it naturally expires, so this is the only reliable
 *  per-request signal that the device session should be torn down
 *  immediately instead of waiting for app relaunch. */
export function isDeviceForbiddenError(error: unknown): boolean {
  if (error instanceof DeviceForbiddenError) return true
  return error instanceof FunctionsHttpError && DEVICE_INVALID_STATUSES.has(error.context?.status)
}
